function ClientViewLoading() {
    return (
        <div className="relative flex justify-center items-center min-h-screen w-full flex-col overflow-x-hidden">
            <div className="w-10 h-10 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"></div>
        </div>
    );
}

export default ClientViewLoading;